import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=1d7661b3&"
import script from "./CategoryFilter.vue?vue&type=script&lang=ts&"
export * from "./CategoryFilter.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d7661b3')) {
      api.createRecord('1d7661b3', component.options)
    } else {
      api.reload('1d7661b3', component.options)
    }
    module.hot.accept("./CategoryFilter.vue?vue&type=template&id=1d7661b3&", function () {
      api.rerender('1d7661b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/filter/CategoryFilter.vue"
export default component.exports